import { aboutInfo } from '@/mocks/chiguaData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-14 items-center">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
              关于我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-[600px] mx-auto lg:mx-0">
              {aboutInfo.description}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8">
              {aboutInfo.stats.map((stat, idx) => (
                <div key={idx} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[480px]">
            <img
              src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20rendering%20of%20a%20modern%20digital%20newsroom%20with%20multiple%20floating%20screens%20showing%20colorful%20abstract%20content%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%20aesthetic%2C%20editorial%20team%20concept%2C%20soft%20glow%2C%20clean%20composition&width=960&height=720&seq=about-2026&orientation=landscape"
              alt="91在线吃瓜团队"
              className="w-full h-auto rounded-2xl"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}